import gql from 'graphql-tag';

export const DECLINE_INVITATION = gql`
  mutation declineClientInvitation($input: DeclineClientInvitationInput!) {
    declineClientInvitation(input: $input) {
      redirectTo
    }
  }
`;
